<template>
    <div>
        <div class="card card-default">
            <div class="card-header">
                <div class="fw-600 float-left font-size-large">Customer</div>
            </div>
                <div class="table-responsive">
                    <table class="table table-valign-middle mb-0">
                        <thead>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>&nbsp;</th>
                        </thead>
                        <tbody>
                            <tr v-for="customer in customers" :key="customer.id">
                                <td>
                                    <div class="btn-table-align">
                                        {{ customer.name }}
                                    </div>
                                </td>

                                <td>
                                    <div class="btn-table-align">
                                        <a :href="'mailto:' + customer.email">{{customer.email}}</a>
                                    </div>
                                </td>

                                <td>
                                    <div class="btn-table-align">
                                        <a :href="'tel:' + customer.phone">{{customer.phone}}</a>
                                    </div>
                                </td>

                                <td class="td-fit">
                                    <button class="btn btn-info" @click="approveTeamMemberDelete(customer)">
                                    Remove
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        <!-- Delete Team Member Modal -->
        <div class="modal" id="modal-delete-customer" tabindex="-1" role="dialog">
            <div class="modal-dialog" v-if="deletingTeamMember">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Remove {{ deletingTeamMember.name }} as customer
                        </h5>
                    </div>

                    <div class="modal-body">
                        Are you sure you want to remove <strong>{{ deletingTeamMember.name }}</strong> from this project?
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Nevermind, do not remove</button>

                        <button type="button" class="btn btn-danger" @click="deleteMember(deletingTeamMember)" :disabled="deleteTeamMemberForm.busy">
                            Yes, remove
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user', 'project'],

        mounted: function() {

        },

        /**
         * The component's data.
         */
        data: function() {
            return {
                customers: this.project.customers,  
                deletingTeamMember: null,
                deleteTeamMemberForm: new SparkForm({})
            };
        },

        computed: {
        },

        watch: {
            project: function (newProject, oldProject) {
                //this.refresh();
                this.customers = newProject.customers;
            }
        },

        /**
         * The component has been created by Vue.
         */
        created: function() {
            //this.getCustomer();
        },

        methods: {
            getCustomer: function() {
                if (this.project && this.project.customer_id_1) {
                    this.loading = true;
                    axios.get(`/api/customer/${this.project.customer_id_1}`)
                        .then(response => {
                            this.loading = false;
                            this.customers = [response.data];
                        })
                        .catch(error => {
                            this.loading = false;
                            console.log(error);
                        });
                }
                else {
                    this.loading = false;
                }
            },

            refresh: function() {
                this.loading = true;
                this.getCustomer();
            },

            /**
             * Display the approval modal for the deletion of a team member.
             */
            approveTeamMemberDelete(member) {
                this.deletingTeamMember = member;
                $('#modal-delete-customer').modal('show');
            },


            /**
             * Delete the given team member.
             */
            deleteMember(customer) {
                axios.delete(`/api/projects/${this.project.id}/customer/${customer.id}`)
                    .then((response) => {
                        Bus.$emit('refresh-current-project');
                        $('#modal-delete-customer').modal('hide');
                    })
                    .catch(error => {
                        $('#modal-delete-customer').modal('hide');
                    });
            },
        }
    }
</script>
